<template>
	<div>
		<nav v-if="showNavigation" class="navbar">
			<div class="nav-brand">Бухгалтерия</div>
			<div class="nav-links">
				<router-link to="/spare-components" class="nav-link">Прайс-лист</router-link>
				<router-link to="/suppliers" class="nav-link">Поставщики</router-link>
				<router-link to="/request-archives" class="nav-link">Архив заявок</router-link>
				<button type="button" class="logout-button" @click="logout">Выйти</button>
			</div>
		</nav>
		<main class="main-content">
			<PrimeToast />
			<router-view />
		</main>
	</div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { clearStoredAuth, isAuthenticated } from './auth';

const route = useRoute();
const router = useRouter();

const showNavigation = computed(() => route.path !== '/login' && isAuthenticated());

const logout = async () => {
	clearStoredAuth();
	await router.replace('/login');
};
</script>

<style>
* {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
}

body {
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
	background-color: #f5f5f5;
}

.navbar {
	background-color: #2c3e50;
	color: white;
	padding: 1rem 2rem;
	display: flex;
	justify-content: space-between;
	align-items: center;
	box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.nav-brand {
	font-size: 1.5rem;
	font-weight: bold;
}

.nav-links {
	display: flex;
	gap: 2rem;
	align-items: center;
}

.nav-link {
	color: white;
	text-decoration: none;
	padding: 0.5rem 1rem;
	border-radius: 4px;
	transition: background-color 0.2s;
}

.nav-link:hover {
	background-color: rgba(255, 255, 255, 0.1);
}

.nav-link.router-link-active {
	background-color: #3498db;
}

.logout-button {
	background: transparent;
	color: #ffffff;
	border: 1px solid rgba(255, 255, 255, 0.35);
}

.main-content {
	padding: 2rem;
	max-width: 1400px;
	margin: 0 auto;
}

h1, h2 {
	margin-bottom: 1.5rem;
	color: #2c3e50;
}

button {
	padding: 0.5rem 1rem;
	border: none;
	border-radius: 4px;
	cursor: pointer;
	font-size: 0.9rem;
	transition: background-color 0.2s;
}

button:hover {
	opacity: 0.9;
}

input[type="text"],
input[type="email"],
input[type="number"],
input[type="password"] {
	padding: 0.5rem;
	border: 1px solid #ddd;
	border-radius: 4px;
	font-size: 0.9rem;
	margin-right: 0.5rem;
}

table {
	width: 100%;
	border-collapse: collapse;
	background: white;
	box-shadow: 0 2px 4px rgba(0,0,0,0.1);
	border-radius: 4px;
	overflow: hidden;
}

th, td {
	padding: 0.75rem;
	text-align: left;
	border-bottom: 1px solid #eee;
}

th {
	background-color: #f8f9fa;
	font-weight: 600;
	color: #2c3e50;
}

tr:hover {
	background-color: #f8f9fa;
}
</style>
